import React, {Component} from 'react';

import Login from './Login';
import Logout from './Logout';
import {Route, Redirect, Switch} from 'react-router-dom';
import MatchWhenLoggedIn from './MatchWhenLoggedIn';
import TopArea from './main/TopArea'
import PrintDispatcher from './print/PrintDispatcher'
import {client} from '../Client';
import ErrorMessage from './ErrorMessage';
import LoadingFrame from './LoadingFrame';

import '../styles/App.css';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
        client.loadConfigurazione((cfg, err) => {this.cfgLoaded(cfg, err)});
    }

    cfgLoaded(cfg, error){
        if (cfg !== undefined){
            client.setConfigurazione(cfg);
            this.setState({cfg: cfg}, ()=>{});
        }
        else {
            this.setState({error: error});
        }
    }

    render() {
        /*
            L'applicazione parte solo dopo che le cfg sono state caricate correttamente dal database
         */
        if (this.state.cfg){
            return (
                <div style={{height: '100%'}}>
                    <iframe id="ifmcontentstoprint" style={{height: "0px", width: "0px", position: "absolute"}}></iframe>
                    <Switch>
                        <Route path='/login' component={Login} />
                        <Route path='/logout' component={Logout} />
                        <MatchWhenLoggedIn path='/app/' component={TopArea} />
                        <MatchWhenLoggedIn path='/print/' component={PrintDispatcher} />
                        <Route render={() => (
                            <Redirect
                                to='/app/'
                            />
                        )} />
                    </Switch>
                </div>)
        }
        else if (this.state.error === undefined) {
            return <div className="ui two column centered grid">
                <div className="column">
                    <LoadingFrame visible="true" testo="Caricamento configurazione in corso..."/>
                </div>
            </div>
        }
        else {
            return <div className="ui two column centered grid">
                <div className="column">
                    <ErrorMessage
                        title="Caricamento configurazione"
                        msg="Errore durante il caricamento delle configurazioni del programma. Impossibile continuare."
                    />
                </div>
            </div>
        }
    }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/